<template>
    <Question
        :question="question"
        :answers="answers"
        @select="$emit('action', $event)"
    />
</template>

<script>
import Question from '../Question';

export default {
    name: 'StartedQuestion',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        question: 'Вы начали обучение?',
        answers: [
            { key: 'start', text: 'Да' },
            { key: 'view_cancel', text: 'Нет' },
        ],
    }),
    components: {
        Question,
    },
};
</script>

<style scoped lang="scss">
</style>